<template>
  <div id="appleid-signin" data-type="sign in" class="apple-login-container" @click="handleClickSign"></div>
</template>

<script>
export default {
  name: 'AppleLogin',
  data() {
    return {
      config: {
        clientId: 'cn.com.csgct.signin',
        scope: 'name email',
        redirectUri: `/home/appleRedirect`,
      },
      appleAuthInstance: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initAppleLogin()
      }, 500)
    })
  },
  beforeDestroy() {
    this.appleAuthInstance = null
  },
  methods: {
    initAppleLogin() {
      if (!window.AppleID) {
        const errMsg = '苹果登录SDK加载失败，请检查网络或引入链接'
        this.$emit('error', { message: errMsg })
        this.$emit('complete')
        return
      }
      window.AppleID.auth.init({
        clientId: this.config.clientId,
        scope: this.config.scope,
        redirectURI: this.$store.state.req_url3 + this.config.redirectUri,
        // redirectURI: 'https://t-app-api.vbdata.cn/home/appleRedirect',
        state: this.$route.fullPath,
        usePopup: false,
      })
    },
    handleClickSign() {
      this.appleAuthInstance = window.AppleID.auth.signIn({
        success: (res) => this.$emit('success', res),
        error: (err) => {
          // 错误码说明：user_cancelled_authorize 是用户主动取消授权，可友好提示
          if (err.error === 'user_cancelled_authorize') {
            console.info('已取消苹果登录授权')
          } else {
            console.error('苹果登录授权失败，请重试')
          }
        },
        complete: () => {
          console.log('苹果登录流程结束')
        },
      })
    },
  },
}
</script>
<style lang="stylus" scoped>
/* 苹果登录按钮容器样式，可根据需求自定义宽高 */
.apple-login-container
  width 100%
  height 34px
  cursor pointer
  >>> div
    padding 0 !important
</style>